import { Link } from 'react-router-dom';

export default function Navigation() {
  return (
    <nav className="bg-gradient-to-r from-purple-600 to-pink-600 shadow-lg sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 text-white font-bold text-xl hover:opacity-90 transition">
            <span className="text-2xl">✨</span>
            <span>Wellness</span>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-6 flex-wrap">
            <Link
              to="/"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              Home
            </Link>
            <Link
              to="/check-in"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              Check-In
            </Link>
            <Link
              to="/reflective-chat"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              Chat
            </Link>
            <Link
              to="/cbt-tools"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              CBT Tools
            </Link>
            <Link
              to="/insights"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              Insights
            </Link>
            <Link
              to="/about"
              className="text-white hover:bg-white hover:bg-opacity-20 px-3 py-2 rounded-lg transition text-sm"
            >
              About
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
